import { render, staticRenderFns } from "./OutboundScale.vue?vue&type=template&id=48e94674&scoped=true"
import script from "./OutboundScale.vue?vue&type=script&lang=js"
export * from "./OutboundScale.vue?vue&type=script&lang=js"
import style0 from "./OutboundScale.vue?vue&type=style&index=0&id=48e94674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e94674",
  null
  
)

export default component.exports